const mapServicesToCamelCase = (services, serviceProviderId) =>
  (services || []).map((service) => ({
    id: service.id,
    serviceId: service.service_offered_id || service.id,
    instanceId: service.id || Math.random(),
    name: service.service_name,
    label: service.label,
    multiplier: service.service_multiplier || 1,
    serviceProviderId: service.service_provider_id || serviceProviderId,
    value: service.service_total_value || service.service_average_value,
  }));

export default mapServicesToCamelCase;
